@if (itemCount && itemCount > 1) {
  <div class="text-sm" *transloco="let t">
    {{ t('createJobRequest.installLampsForm.definedLampsLabel') }}
    <span
      class="inline-block rounded-1 px-sm py-px text-xs"
      [ngClass]="{
        'bg-orange-500 text-primary': optionCount !== itemCount,
        'bg-green-500 text-white': optionCount === itemCount,
      }"
      data-testid="count"
    >
      {{ optionCount }}
      {{ t('createJobRequest.installLampsForm.definedLampsCountOf') }}
      {{ itemCount }}
    </span>
  </div>
}
